import { render, staticRenderFns } from "./VChooseTask.vue?vue&type=template&id=670197f0&"
import script from "./VChooseTask.vue?vue&type=script&lang=ts&"
export * from "./VChooseTask.vue?vue&type=script&lang=ts&"
import style0 from "./VChooseTask.vue?vue&type=style&index=0&id=670197f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports